__turbopack_context__.v({
  "chip": "chip-module__6KJUvq__chip",
  "clickable": "chip-module__6KJUvq__clickable",
});
